import axios from 'axios';
import { IHrInterests } from '../models/Profile/IHrInterests';
import { IProfile } from '../models/Profile/IProfile';
import { IProfilePhoto } from '../models/Profile/IProfilePhoto';
import { commonService } from './commonDashboardApiService';
import { env } from '../env';

function profileService() {
  function getProfile<IProfileContainer>(id: string) {
    return commonService.get<IProfileContainer>(`api/profile/${id}`);
  }

  function getProfilePhoto(id: string) {
    return commonService.get('api/profile/GetProfilePhoto', {
      params: { ssoUUId: id },
    });
  }

  function deleteProfilePhoto(id: number) {
    return commonService.del('api/profile/DeleteProfilePhoto', {
      params: { id: id },
    });
  }

  function getChaptersForState(id: string, stateCode: string, membershipType: string) {
    return commonService.get('api/profile/GetChapterNamesForState', {
      params: { memberId: id, stateCode: stateCode, membershipType: membershipType },
    });
  }

  function updateProfile(id: string, data: IProfile) {
    return commonService.post(`api/profile/${id}`, data);
  }

  function uploadProfilePhoto(profilePhoto: IProfilePhoto) {
    return commonService.post('api/profile/UploadProfilePhotoToCloudinary', profilePhoto);
  }

  function saveProfilePhoto(profilePhoto: IProfilePhoto) {
    return commonService.post('api/profile/SaveProfilePhoto', profilePhoto);
  }

  function getDnbName(dnbToken: string, searchTerm: string) {
    return commonService.get('api/profile/GetDnbName', {
      params: { dnbToken: dnbToken, searchTerm: searchTerm, _: Date.now() },
    });
  }

  function getCollegeName(searchTerm: string) {
    return commonService.get('api/profile/GetCollegeName', {
      params: { searchTerm: searchTerm, _: Date.now() },
    });
  }
  return {
    getProfile,
    getProfilePhoto,
    getChaptersForState,
    updateProfile,
    deleteProfilePhoto,
    uploadProfilePhoto,
    saveProfilePhoto,
    getCollegeName,
    getDnbName,
  };
}

export default profileService;
